<script setup lang="ts">
import { ref, computed } from 'vue'
import { RouterLink, useLink } from 'vue-router'

interface TProps {
  isMobile?: boolean
  fallbackText?: string
  to?: string
  tag?: string
  cssClass?: string
  overrideCssClass?: string
  prefetch?: boolean
}

const props = withDefaults(defineProps<TProps>(), {
  isMobile: false,
  fallbackText: 'Link',
  to: '/',
  tag: 'div',
  cssClass: '',
  overrideCssClass: '',
  prefetch: false,
})

const emits = defineEmits<{
  (e: 'clicked'): any
}>()

const { navigate, href, route, isActive, isExactActive } = useLink(props)

const computedCssClass = computed((): string => {
  if ((props.overrideCssClass || '').trim().length > 0) {
    return (props.overrideCssClass || '').trim()
  }

  let result = ''

  if ((props.cssClass || '').trim().length > 0) {
    result = (props.cssClass || '').trim()
    if (!!props.isMobile) {
      result = `block ${result}`
    }
  } else {
    result =
      'rounded-md py-2 px-3 text-sm font-medium leading-5 bg-none hover:bg-primary hover:content-primary focus:outline-none transition duration-150 ease-in-out'
    //result =
    //  'text-primary hover:bg-primary hover:content-primary rounded-md px-3.5 py-2.5 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2'
    if (!!props.isMobile) {
      result = `block text-base ${result}`
    }
  }

  // NuxtLink could be done through nuxt.config.ts router section (i.e. linkActiveClass etc)
  // but we think is better here
  if (!!isActive.value) {
    result = `bg-primary content-primary ${result}`
  } else {
    result = `content-body ${result}`
  }

  return result
})

const onClick = () => {
  emits('clicked')
}
</script>

<template>
  <ClientOnly fallback-tag="span" :fallback="fallbackText">
    <NuxtLink
      tabindex="0"
      :class="computedCssClass"
      :to="to"
      :tag="tag"
      :prefetch="prefetch"
      @click.native="onClick"
    >
      <slot></slot>
    </NuxtLink>
  </ClientOnly>
</template>
